import { Directive, ElementRef, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';

@Directive({
  selector: '[suppressEvents]',
  inputs: [],
  outputs: ['onClick'],
  standalone: false
})
export class SuppressEventsDirective implements AfterViewInit, OnDestroy {
  suppressEvents: string[] = ['click', 'mousedown', 'touchdown', 'touchmove', 'touchstart'];
  onClick: any = new EventEmitter();

  private _handlers: { evName: string; fn: EventListener }[] = [];

  constructor(public element: ElementRef) {}

  ngAfterViewInit() {
    const el = this.element.nativeElement;

    this._handlers = this.suppressEvents.map(evName => {
      const fn: EventListener = event => this.stopBubble(event);
      el.addEventListener(evName, fn);
      return { evName, fn };
    });

    const touchendFn: EventListener = event => {
      this.stopBubble(event);
      this.onClick.emit(event);
    };
    el.addEventListener('touchend', touchendFn);
    this._handlers.push({ evName: 'touchend', fn: touchendFn });

    const mouseupFn: EventListener = event => this.onClick.emit(event);
    el.addEventListener('mouseup', mouseupFn);
    this._handlers.push({ evName: 'mouseup', fn: mouseupFn });
  }

  ngOnDestroy() {
    const el = this.element.nativeElement;
    this._handlers.forEach(({ evName, fn }) => el.removeEventListener(evName, fn));
    this._handlers = [];
  }

  stopBubble(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }
}
